import React from "react";
import { string, node, func } from "prop-types";

const DisplaySelect = ({
  placeholder,
  name,
  errors,
  children,
  onClick,
  className = "",
  customError = "",
}) => {
  return (
    <div className={`display-select ${className}`} onClick={onClick}>
      <div className="display-select__content">
        <div className="display-select__placeholder">{placeholder}</div>
        <div className="display-select__children">{children}</div>
      </div>
      {errors && errors[name] && (
        <span className="display-select__errors">
          {errors[name]?.message || customError}
        </span>
      )}
    </div>
  );
};

DisplaySelect.propTypes = {
  placeholder: string.isRequired,
  children: node.isRequired,
  onClick: func,
  className: string,
};

DisplaySelect.propTypes = {
  onClick: () => {},
};

export default DisplaySelect;
